import { useContext, useState, useEffect, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import VegIcon from "../../Icon/veg.svg";
import NonVegIcon from "../../Icon/nonveg.svg";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { showToast } from '../../showTost';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import DeliverLogo from "../../Image/deliverypartner.png";
import Razorpay from '../../Payment/Razorpay';
import AddonItemData from './AddonItemData';
import SubAddonItemData from './SubAddonItemData';
import Paypal from '../../Payment/Paypal';
import PayStack from '../../Payment/PayStack';
import Stripe from '../../Payment/Stripe';
import FlutterWave from '../../Payment/FlutterWave';
import PaytmPayment from '../../Payment/Paytm';
import PayFast from '../../Payment/PayFast';
import MercadoPago from '../../Payment/MercadoPago';
import Midtrans from '../../Payment/Midtrans';
import KhaltiPayment from '../../Payment/KhaltiPayment';
import MapPin from "../../Image/placeholder.png";
import { uid } from 'uid';
const Checkout = () => {

  const { BaseUrl, locationsearch, setTotalCart, iscustomisable, setIsVagType, callHomeApi, MapKey, setAdsUpdate, setIsCustomisable, setPaymentLoading, customisableitem, setCustomisableItem, paymentloading, paymentRes, setPaymentRes, setShowLoginPage } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [apiloading, setApiLoading] = useState(false);
  const [saveaddres, setSaveAddres] = useState([]);
  const [selectaddres, setSelectAddres] = useState("");
  const [localcartdata, setLocalCartData] = useState([]);
  const [isselect, setIsSelect] = useState(false);
  const [cartdata, setCartData] = useState([]);
  const [restaurantdata, setRestaurantData] = useState("");
  const [couponlist, setCouponList] = useState([]);
  const [showcoupon, setShowCoupon] = useState(false);
  const [itemtotal, setItemTotal] = useState(0);
  const [totalpay, setTotalPay] = useState(0);
  const [selectcoupon, setSelectCoupon] = useState("");
  const [loadingCouponCode, setLoadingCouponCode] = useState(null);
  const [tax, setTax] = useState(0);
  const [tip, setTip] = useState(0);
  const [showaddress, setShowAddress] = useState(false);
  const [mapcoords, setMapCoords] = useState({ lat: "", long: "" });
  const [selectcoords, setSelectCoords] = useState({ lat: "", long: "" });
  const [mapaddres, setMapAddres] = useState("");
  const [mapdata, setMapData] = useState({ houseno: "", landmark: "", type: "" });
  const [selecttip, setSelectTip] = useState(0);
  const [additionalnot, setAdditionalNot] = useState("");
  const [paymentlist, setPaymentList] = useState([]);
  const [showpayment, setShowPayment] = useState(false);
  const [selectpayment, setSelectPayment] = useState("");
  const [attributes, setAttributes] = useState("");
  const [istrue, setIsTrue] = useState(false);
  const [istype, setIsType] = useState("");
  const [productData, setProductData] = useState([]);
  const [selectitem, setSelectItem] = useState("");
  const [selectaddonitem, setSelectAddonItem] = useState([]);
  const [addonlimit, setAddonLimit] = useState(0);
  const [itemstate, setItemState] = useState([]);
  const [copyitemstate, setCopyItemState] = useState([]);
  const [subaddonshow, setSubAddonShow] = useState(false);
  const [isstep, setIsStep] = useState("1");
  const [selectitemprice, setSelectItemPrice] = useState(0);
  const [isedit, setIsEdit] = useState(0);
  const [subAddonData, setSubAddonData] = useState("");
  const [minamount, setMinAmount] = useState(0);
  const [showoption, setShowOtion] = useState("");
  const [editadsid, setEditAdsId] = useState("");
  const [selectitemqty, setSelectItemQty] = useState(1);
  const [ischange, setIsChange] = useState(false);
  const [isshow, setIsShow] = useState(false);
  const [deleteadsid, setDeleteadsId] = useState("");
  const [mywallet, setMyWallet] = useState(0);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [usedwallet, setUsedWallet] = useState(0);
  const [baseTotal, setBaseTotal] = useState(0);

  const StyleRef = useRef();

  const AddresType = [
    {
      type: "Home", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 21.75H13.75V16.5C13.75 15.535 12.965 14.75 12 14.75C11.035 14.75 10.25 15.535 10.25 16.5V21.75H6C3.582 21.75 2.25 20.418 2.25 18V11.65C2.25 9.52704 2.83599 8.93401 3.79199 8.14101L9.91199 3.01003C11.121 1.99503 12.879 1.99503 14.088 3.01003L20.208 8.14101C21.164 8.93401 21.75 9.52804 21.75 11.65V18C21.75 20.418 20.418 21.75 18 21.75ZM15.25 20.25H18C19.577 20.25 20.25 19.577 20.25 18V11.65C20.25 10.124 19.998 9.91506 19.251 9.29506L13.125 4.15908C12.473 3.61308 11.527 3.61308 10.875 4.15908L4.74902 9.29506C4.00202 9.91506 3.75 10.124 3.75 11.65V18C3.75 19.577 4.423 20.25 6 20.25H8.75V16.5C8.75 14.708 10.208 13.25 12 13.25C13.792 13.25 15.25 14.708 15.25 16.5V20.25Z" fill="currentColor" />
      </svg>
    },
    {
      type: "Office", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 20.25H20.25V6C20.25 3.582 18.918 2.25 16.5 2.25H7.5C5.082 2.25 3.75 3.582 3.75 6V20.25H3C2.586 20.25 2.25 20.586 2.25 21C2.25 21.414 2.586 21.75 3 21.75H21C21.414 21.75 21.75 21.414 21.75 21C21.75 20.586 21.414 20.25 21 20.25ZM13.5 20.25H10.5V17.5C10.5 16.911 10.661 16.75 11.25 16.75H12.75C13.339 16.75 13.5 16.911 13.5 17.5V20.25ZM15 20.25V17.5C15 16.091 14.159 15.25 12.75 15.25H11.25C9.841 15.25 9 16.091 9 17.5V20.25H5.25V6C5.25 4.423 5.923 3.75 7.5 3.75H16.5C18.077 3.75 18.75 4.423 18.75 6V20.25H15ZM15.75 13C15.75 13.414 15.414 13.75 15 13.75H14C13.586 13.75 13.25 13.414 13.25 13C13.25 12.586 13.586 12.25 14 12.25H15C15.414 12.25 15.75 12.586 15.75 13ZM10.75 13C10.75 13.414 10.414 13.75 10 13.75H9C8.586 13.75 8.25 13.414 8.25 13C8.25 12.586 8.586 12.25 9 12.25H10C10.414 12.25 10.75 12.586 10.75 13ZM15.75 10C15.75 10.414 15.414 10.75 15 10.75H14C13.586 10.75 13.25 10.414 13.25 10C13.25 9.586 13.586 9.25 14 9.25H15C15.414 9.25 15.75 9.586 15.75 10ZM10.75 10C10.75 10.414 10.414 10.75 10 10.75H9C8.586 10.75 8.25 10.414 8.25 10C8.25 9.586 8.586 9.25 9 9.25H10C10.414 9.25 10.75 9.586 10.75 10ZM15.75 7C15.75 7.414 15.414 7.75 15 7.75H14C13.586 7.75 13.25 7.414 13.25 7C13.25 6.586 13.586 6.25 14 6.25H15C15.414 6.25 15.75 6.586 15.75 7ZM10.75 7C10.75 7.414 10.414 7.75 10 7.75H9C8.586 7.75 8.25 7.414 8.25 7C8.25 6.586 8.586 6.25 9 6.25H10C10.414 6.25 10.75 6.586 10.75 7Z" fill="currentColor" />
      </svg>
    }, {
      type: "Other", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="currentColor" />
      </svg>
    }
  ];

  const navigate = useNavigate();
  const currency = secureLocalStorage.getItem("currency");
  const TaxPrs = secureLocalStorage.getItem("Tax");
  const WalletAmt = secureLocalStorage.getItem("walletamt") || "0";

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: MapKey
  });

  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {

    window.scrollTo(0, 0);
    setLoading(true);

    const LocalData = secureLocalStorage.getItem("localcartdata");
    if (LocalData) {
      var { cartitem, restdata } = JSON.parse(LocalData);
      setCartData(cartitem);
      const totalcart = cartitem.reduce((sum, item) => sum + item.qty, 0);
      setTotalCart(totalcart);
      handleGetCouponList(restdata?.rest_id);
      const Tip = secureLocalStorage.getItem("Tip");
      if (Tip) {
        setTip(Tip.split(","));
      }
    } else {
      navigate(-1);
    }

    const savedLocation = secureLocalStorage.getItem("Location");

    if (savedLocation) {
      try {
        const { lat, long } = JSON.parse(savedLocation);
        setMapCoords({ lat, long });
        setSelectCoords({ lat, long });
        handleFetchData(restdata?.rest_id, lat, long);
        handleCartApi(restdata?.rest_id, lat, long);
        handleGetPaymentList(restdata?.rest_id, lat, long);
      } catch (error) {
        console.error("Error parsing saved location:", error);
      }
    } else {
      navigator.geolocation.getCurrentPosition(
        position => {
          const lat = position.coords.latitude;
          const long = position.coords.longitude;
          setMapCoords({ lat, long });
          setSelectCoords({ lat, long });
          handleFetchData(restdata?.rest_id, lat, long);
          handleCartApi(restdata?.rest_id, lat, long);
          handleGetPaymentList(restdata?.rest_id, lat, long);
        },
        error => {
          console.error("Geolocation error:", error);
        }
      );
    }

    setMyWallet(Number(WalletAmt));

    const PaymentRes = sessionStorage.getItem("Paymentstatus");
    if (PaymentRes) {
      if (PaymentRes === "PaymentDone") {
        setPaymentRes("PaymentDone");
      } else {
        setPaymentRes("PaymentFail");
      }
    }

    handleGetAddresList();
  }, [callHomeApi]);

  useEffect(() => {
    const TotalCost = cartdata.reduce((sum, item) => sum + item.cost, 0);
    setItemTotal(TotalCost);
    if (TaxPrs) {
      const TotalTax = (TotalCost / Number(TaxPrs));
      setTax(TotalTax.toFixed(0));
    }
  }, [cartdata]);

  useEffect(() => {
    const TotalPay =
      Number(restaurantdata?.rest_dcharge) +
      Number(restaurantdata?.rest_charge) +
      Number(tax) +
      Number(itemtotal);

    const FinalTotal = selectcoupon
      ? TotalPay - selectcoupon?.cvalue
      : TotalPay;

    setBaseTotal(FinalTotal);
    setTotalPay(FinalTotal + Number(selecttip));

  }, [itemtotal, tax, restaurantdata, selectcoupon, selecttip]);

  useEffect(() => {
    if (isDriverSelected) {
      if (mywallet < totalpay) {
        setUsedWallet(mywallet);
        setTotalPay(totalpay - mywallet);
      } else {
        setUsedWallet(totalpay);
        setTotalPay(0);
      }
    } else {
      setUsedWallet(0);
      setTotalPay(baseTotal + Number(selecttip));
    }
  }, [isDriverSelected]);

  useEffect(() => {
    if (selectcoupon) {
      if (itemtotal < Number(selectcoupon.minamt)) {
        setSelectCoupon("");
      }
    }
  }, [itemtotal]);

  useEffect(() => {
    const TotalAddonPrice = selectaddonitem?.reduce((sum, item) => sum + Number(item.price), 0);
    const TotalAddonPrice2 = itemstate?.map(item => item.data?.reduce((sum, item) => sum + Number(item.price), 0)).join(", ");
    const FinalPrice = (TotalAddonPrice + Number(TotalAddonPrice2)) * selectitemqty;
    setSelectItemPrice(FinalPrice);
  }, [selectaddonitem, itemstate]);

  const handleFetchData = (rid, lats, longs) => {
    const uid = secureLocalStorage.getItem("Userid") || "0";
    if (uid) {
      axios.post(`${BaseUrl}/eapi/e_rest_data.php`, { uid, rid, fid: 0, lats, longs })
        .then((res) => {
          // console.log("e_rest_data.php", res.data);
          setMinAmount(res.data.RestData.restuarant_data[0].rest_morder);
          setProductData(res.data.RestData.Product_Data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("e_rest_data.php", error);
        });
    }
  }

  const handleCartApi = (rid, lats, longs) => {
    axios.post(`${BaseUrl}/eapi/e_cart_data.php`, { rid, lats, longs })
      .then((res) => {
        console.log("e_cart_data.php", res.data);
        setRestaurantData(res.data.restuarant_data[0]);
      })
      .catch((error) => {
        console.error("e_cart_data.php", error);
      })
  }

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const long = event.latLng.lng();

    axios.post(`${BaseUrl}/eapi/zone_check.php`, { lats: lat, longs: long })
      .then((res) => {
        console.log(res);
        if (res.data.ResponseCode == 200) {
          setMapCoords({ lat, long });
          HandleGetGoogleAddress(lat, long);
        } else {
          showToast({ title: "Services is not provided in this area.", id: "info" });
        }
      })
      .catch((error) => {
        console.error("zone_check", error);
      });

  };

  const handleNavigete = () => {
    navigate(`/restaurant/${restaurantdata?.rest_id}`);
  }

  const handleGetCouponList = (rid) => {
    axios.post(`${BaseUrl}/eapi/e_couponlist.php`, { rid })
      .then((res) => {
        // console.log("e_couponlist.php", res.data);
        setCouponList(res.data.couponlist);
      })
      .catch((error) => {
        console.error("e_couponlist.php", error);
      })
  }

  const handleCheckCoupone = (data) => {
    const uid = secureLocalStorage.getItem("Userid");
    setLoadingCouponCode(data.coupon_code);

    axios.post(`${BaseUrl}/eapi/e_check_coupon.php`, { uid, cid: data.id })
      .then((res) => {
        // console.log("e_check_coupon.php", res.data);
        const { ResponseCode, ResponseMsg } = res.data;
        const Toastid = ResponseCode === "200" ? "success" : "error";
        showToast({ title: ResponseMsg, id: Toastid });
        if (ResponseCode === "200") {
          setSelectCoupon({ cid: data.id, cvalue: data.c_value, ccode: data.coupon_code, minamt: data.min_amt });
          setShowCoupon(false);
        }
        setLoadingCouponCode(null);
      })
      .catch((error) => {
        console.error("e_check_coupon.php", error);
      })
  }

  const HandleGetGoogleAddress = async (lat, lng) => {

    setShowAddress(true);
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const components = results[0].address_components;

        const getComponent = (type) => {
          const comp = components.find(c => c.types.includes(type));
          return comp?.long_name || '';
        };

        const thoroughfare = getComponent('route');
        const subLocality = getComponent('sublocality');
        const locality = getComponent('locality');
        const subAdminArea = getComponent('administrative_area_level_2');
        const postalCode = getComponent('postal_code');
        const adminArea = getComponent('administrative_area_level_1');

        const fulladdress =
          `${thoroughfare ? thoroughfare + ', ' : ''}` +
          `${subLocality ? subLocality + ', ' : ''}` +
          `${locality ? locality + ', ' : ''}` +
          `${subAdminArea ? subAdminArea + ', ' : ''}` +
          `${postalCode ? postalCode + ', ' : ''}` +
          `${adminArea || ''}`;

        setMapAddres(fulladdress);

      } else {
        console.log('Address not found');
      }
    });
  };

  const handleGetAddresList = () => {
    const uid = secureLocalStorage.getItem("Userid");
    axios.post(`${BaseUrl}/eapi/e_address_list.php`, { uid })
      .then((res) => {
        // console.log("e_address_list.php", res);
        const AddresList = res.data.AddressList;
        const AllType = ["Home", "Office"];
        setSaveAddres(AddresList);
        const FilterAddres = AddresList?.map(item => {
          if (AllType.includes(item.type)) {
            return item.type;
          }
          return null;
        }).filter(Boolean);

        setIsType(FilterAddres);
      })
      .catch((error) => {
        console.error("e_address_list.php", error);
      })
  }

  const handleGetPaymentList = (rid, lats, longs) => {
    axios.post(`${BaseUrl}/eapi/e_cart_data.php`, { rid, lats, longs })
      .then((res) => {
        // console.log("e_cart_data.php", res);
        setPaymentList(res.data.paymentdata);
      })
      .catch((error) => {
        console.error("e_cart_data.php", error);
      });
  }

  const handleSaveAddres = () => {

    const { houseno, type, landmark } = mapdata;

    if (!houseno || !type || !landmark) {
      showToast({ title: "Fill all details !!", id: "error" })
      return;
    }

    setApiLoading(true);
    const uid = secureLocalStorage.getItem("Userid");

    const ApiData = {
      uid,
      address: mapaddres,
      houseno: houseno,
      type: type,
      lat_map: mapcoords.lat,
      long_map: mapcoords.long,
      aid: editadsid ? editadsid : "0",
      apartment: landmark
    }

    axios.post(`${BaseUrl}/eapi/e_address_user.php`, ApiData)
      .then((res) => {
        // console.log("e_address_user.php", res.data);
        const { ResponseCode, ResponseMsg } = res.data;
        const Toastid = ResponseCode === "200" ? "success" : "error";
        showToast({ title: ResponseMsg, id: Toastid });
        if (ResponseCode === "200") {
          handleGetAddresList();
          setShowAddress(false);
          setMapData("");
          setApiLoading(false);
          setAdsUpdate(prev => prev + 1);
        }
      })
      .catch((error) => {
        console.error("e_address_user.php", error);
      });
  }

  const handleIncrement = (Orderindex, data) => {

    const SelectData = data || cartdata;

    const FilterData = SelectData.map((item, index) => {
      if (index === Orderindex) {
        const Qty = item.qty + 1;
        const Cost = item.copycost * Qty;
        return { ...item, qty: Qty, cost: Cost }
      }
      return item;
    });

    setCartData(FilterData);
    setLocalCartData(FilterData);
    setSelectCoupon("");
    setIsDriverSelected(false);
  }

  const handleDecrement = (Orderindex) => {
    const FilterData = cartdata.map((item, index) => {
      if (index === Orderindex) {
        const Cost = item.cost - item.copycost;
        const Qty = item.qty - 1;
        if (Qty === 0) return null;
        return { ...item, qty: Qty, cost: Cost }
      }
      return item;
    }).filter(Boolean);

    setCartData(FilterData);
    setLocalCartData(FilterData);
    setIsDriverSelected(false);
  }

  useEffect(() => {
    if (loading) return;
    if (localcartdata?.length >= 1) {
      const Data = { cartitem: localcartdata, restdata: { rest_id: restaurantdata.rest_id } }
      secureLocalStorage.setItem("localcartdata", JSON.stringify(Data));
    } else {
      secureLocalStorage.removeItem("localcartdata");
      navigate(-1);
    }
    const totalcart = localcartdata.reduce((sum, item) => sum + item.qty, 0);
    setTotalCart(totalcart);
  }, [localcartdata]);

  const handleProceed = async () => {
    if (itemtotal < minamount) {
      showToast({ title: `Minimum order above ${currency + minamount}`, id: "info" });
      return;
    }

    if (!isselect) {
      showToast({ title: "Select delivery address !!", id: "info" });
      return;
    }

    const ApiData = await handleGetBookingData("5");

    if (totalpay === 0) {
      sessionStorage.setItem("transactionid", "0");
      secureLocalStorage.setItem("Bookdata", ApiData);
      handleBookOrder();
      return;
    }

    setShowPayment(true);
  }

  const handleGetBookingData = (p_method_id) => {
    const uid = secureLocalStorage.getItem("Userid");
    const Tax = secureLocalStorage.getItem("Tax");

    const full_address = `${selectaddres.hno},${selectaddres.landmark},${selectaddres.address}`;
    const ApiData = {
      uid,
      p_method_id,
      rest_id: restaurantdata?.rest_id,
      full_address,
      atype: selectaddres.type,
      d_charge: restaurantdata?.rest_dcharge,
      cou_id: selectcoupon ? selectcoupon.cid : 0,
      cou_amt: selectcoupon ? selectcoupon.cvalue : 0,
      product_total: totalpay,
      product_subtotal: itemtotal,
      a_note: additionalnot,
      wall_amt: usedwallet,
      tax: Tax,
      tip: selecttip || 0,
      rest_charge: restaurantdata?.rest_charge,
      lats: selectcoords.lat,
      longs: selectcoords.long,
      ProductData: handleGetProductData()
    }

    return ApiData;
  }

  const handleGetProductData = () => {
    const FilterData = cartdata.map(item => {
      const Addon = item.addon.map(List => List.data.map(item => item.title)).join(", ");
      return {
        pid: item.pid,
        title: item.title,
        cost: (item.cost / item.qty),
        qty: item.qty,
        type: item.type,
        addon: Addon
      }
    });

    return FilterData;
  }

  const handleContinue = async () => {

    if (paymentloading) return;

    if (!selectpayment) {
      showToast({ title: 'Select payment method !!', id: "error" });
      return;
    }

    const ApiData = await handleGetBookingData(selectpayment);
    secureLocalStorage.setItem("Bookdata", ApiData);

    if (selectpayment !== "2") {
      secureLocalStorage.setItem("pages", "checkout");
      setIsTrue(true);
      setPaymentLoading(true);
    } else {
      setPaymentLoading(true);
      sessionStorage.setItem("transactionid", "0");
      setPaymentRes("PaymentDone");
    }
  }

  useEffect(() => {
    if (!paymentRes) return;

    if (paymentRes === "PaymentDone") {
      handleBookOrder();
    } else {
      showToast({ title: "Payment faild !!", id: "error" });
      setIsTrue(false);
      setSelectPayment("");
      setPaymentRes("");
      sessionStorage.removeItem("Paymentstatus");
      secureLocalStorage.removeItem("Bookdata");
    }
  }, [paymentRes]);

  const handleBookOrder = () => {

    const BookingData = secureLocalStorage.getItem("Bookdata");
    const transaction_id = sessionStorage.getItem("transactionid") || uid(10);

    if (BookingData) {

      axios.post(`${BaseUrl}/eapi/e_order_now.php`, { ...BookingData, transaction_id })
        .then((res) => {
          console.log("e_order_now.php", res.data);
          const { ResponseCode, ResponseMsg } = res.data;
          const Toastid = ResponseCode === "200" ? "success" : "error";
          showToast({ title: ResponseMsg, id: Toastid });
          if (ResponseCode === "200") {
            secureLocalStorage.removeItem("Bookdata");
            sessionStorage.removeItem("transactionid");
            secureLocalStorage.removeItem("localcartdata");
            sessionStorage.removeItem("Paymentstatus");
            secureLocalStorage.setItem("trakingid", res.data.order_id);
            setShowPayment(false);
            setSelectPayment("");
            setIsTrue(false);
            setPaymentRes("");
            setTotalCart(0);
            setPaymentLoading(false);
            navigate("/orders");
          }
        })
        .catch((error) => {
          console.error("e_order_now.php", error);
        });
    }

  }

  const handleSelectAddrestype = (type, IsAdded) => {
    if (IsAdded) {
      showToast({ title: "Add only one time !!", id: "info" })
      return;
    }
    setMapData({ ...mapdata, type: type });
  }

  const handleSelectAddress = (item) => {
    setIsDriverSelected(false);
    handleCartApi(restaurantdata?.rest_id, item.lat_map, item.long_map);
    setSelectCoords({ lat: item.lat_map, long: item.long_map });
    setSelectAddres(item);
    setIsSelect(true);
  }

  const handleCustomisable = (data, index) => {

    setIsVagType(data.type);
    setSelectItemQty(data.qty);
    setIsEdit(index + 1);
    setItemState(data.addon);
    setCopyItemState(data.addon);
    setSelectItem(data);

    const SelectItem = productData.map(product => {
      return product.Menuitem_Data.find(menu => menu.id === data.pid);
    });

    const AllData = [];
    data.addon.map(item => item.data.map(addon => AllData.push(addon)));

    const FilterData = SelectItem[0].addondata.map(item => {
      const IsAdded = item.addon_item_data.map(addon => {
        const isTrue = AllData.find(alldata => alldata.id === addon.id);
        return isTrue || null;
      }).filter(Boolean);
      if (IsAdded) {
        return { ...item, additem: IsAdded.length }
      }
      return item;
    });
    handleFilterData({ ...customisableitem, addondata: FilterData }, data.addon);
    setIsCustomisable(true);

  }

  const handleFilterData = (data, addondata) => {
    const FilterData = data.addondata.map(addon => {
      if (!addon.additem) {

        if (addon.addon_is_radio === "1" && addon.addon_is_required === "1") {

          const FilterItem = addon.addon_item_data.filter(item => {
            return addondata.some(addon => addon.title === item.title)
          });

          setSelectAddonItem(prev => [...prev, ...FilterItem]);

          if (addon.addon_item_data[0].subaddondata.length >= 1) {
            setAddonLimit(1);
          } else {
            setItemState(prev => {
              const exists = (prev || []).some(item => item.title === "Order");
              if (exists) {
                return (prev || []).map(item => {
                  if (item.title === "Order") {
                    return { ...item, data: [...item.data, addon.addon_item_data[0]] };
                  }
                  return item;
                });
              } else {
                return [...(prev || []), { title: "Order", data: [addon.addon_item_data[0]] }];
              }
            });
          }
          return { ...addon, additem: "1" }
        }
        return addon;
      }
      return addon;
    });
    setCustomisableItem({ ...data, addondata: FilterData });
  }

  const handleCloseModel = (index) => {
    if (index === 1) {
      setIsCustomisable(false);
      setItemState([]);
      setSelectAddonItem([]);
      setSelectItemPrice(0);
      setIsStep("1");
      setIsChange(false);
    } else {
      setIsStep("1");
      setIsChange(true);
    }
    setSubAddonShow(false);
  }

  const handleUpdateCart = () => {

    const matchedOrders = cartdata.filter((i, index) => index !== (isedit - 1));
    let Error = false;

    const isMatching = itemstate.every(item => {
      return matchedOrders.some(orders => {
        return orders.addon.some(data => {
          return data.title === item.title;
        });
      });
    });

    if (isMatching) {

      let MatchOrderIndex;

      const handleCheckOrder = (matchedOrders, itemstate) => {
        return itemstate.every(item => {
          return matchedOrders.some((orders, index) => {
            return orders.addon.some(addon => {
              const AddonTitle = addon.data.map(data => data.title).sort();
              const ItemTitle = item.data.map(data => data.title).sort();
              if (AddonTitle.length !== ItemTitle.length) return false;
              const isMatch = AddonTitle.every((title, index) => title === ItemTitle[index]);
              if (isMatch) {
                MatchOrderIndex = index;
              }
              return isMatch;
            })
          })
        })
      }

      const IsValid = handleCheckOrder(matchedOrders, itemstate);

      if (IsValid) {
        const RemoveItem = cartdata.filter((i, index) => index !== (isedit - 1));
        handleIncrement(MatchOrderIndex, RemoveItem);
        handleCloseModel(1);
      } else {
        Error = true;
      }
    } else {
      Error = true;
    }

    if (Error) {
      const FilterLocalCart = cartdata.map((item, index) => {
        if (index === (isedit - 1)) {
          const cost = selectitemprice + Number(item.price * selectitemqty);
          return { ...item, cost, copycost: (cost / selectitemqty), addon: itemstate }
        }
        return item;
      });

      setCartData(FilterLocalCart);
      setLocalCartData(FilterLocalCart);
      handleCloseModel(1);
    }
  }

  const handleContinue2 = () => {

    if (selectaddonitem.length <= 0) {
      showToast({ title: "Please select item !!", id: "error" });
      return;
    }

    const someHaveNoSubaddons = selectaddonitem.some(item => item.subaddondata.length <= 0);

    if (someHaveNoSubaddons) {
      handleUpdateCart();
      return;
    }

    setIsStep("1");
    setSubAddonShow(true);
  }

  const handleEditAddress = (item) => {
    setMapCoords({ lat: item.lat_map, long: item.long_map });
    setMapAddres(item.address);
    setMapData({ houseno: item.hno, landmark: item.landmark, type: item.type });
    setEditAdsId(item.id);
    setShowAddress(true);
  }

  const handleDeleteAddress = (aid) => {
    const uid = secureLocalStorage.getItem("Userid");

    handleShowModel(2);
    axios.post(`${BaseUrl}/eapi/e_add_delete.php`, { uid, aid })
      .then((res) => {
        // console.log("e_add_delete.php", res.data);
        const ToastId = res.data.ResponseCode === "200" ? "success" : "error";
        showToast({ title: res.data.ResponseMsg, id: ToastId });
        if (res.data.ResponseCode === "200") {
          handleGetAddresList();
        }
      })
      .catch((error) => {
        console.error("e_add_delete.php", error);
      })
  }

  const handleShowModel = (index) => {
    if (index === 1) {
      setIsShow(true);
      setTimeout(() => {
        StyleRef.current.classList.add('item_added_close');
      }, 100);
    } else {
      StyleRef.current.classList.remove('item_added_close');
      setTimeout(() => {
        setIsShow(false);
      }, 500);
    }
  }

  return (

    <div onClick={() => setShowOtion("")} className="checkout_page">
      {loading
        ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
          <div className="loader"></div>
        </div>
        : <div className="width_container">
          <div className="flex flex-wrap items-start justify-center gap-[20px] pt-[30px]">

            <div className="select_box">
              <div className="section_1">
                {Userid
                  ? <div className="">
                    {saveaddres?.length >= 1
                      ? <div className="leading-5">
                        <h1 className="text-[#02060c] text-[17px] font-[700]">Choose a delivery address</h1>
                        <p className="text-[rgba(2,6,12,.6)] font-[500]">Multiple addresses in this location</p>
                      </div>
                      : <div className="leading-5">
                        <h1 className="text-[#02060c] text-[17px] font-[700]">Add a delivery address</h1>
                        <p className="text-[rgba(2,6,12,.6)] font-[500]">You seem to be in the new location</p>
                      </div>}
                    <div className="mt-[20px]">
                      {saveaddres?.map((item, index) => {
                        const isSelect = selectaddres ? selectaddres.id === item.id : false;
                        const isOpen = showoption === item.id;
                        return <div key={index} onClick={() => handleSelectAddress(item)} className={`addres_box relative ${isSelect ? "select_addres" : ""}`}>
                          {isSelect && <div className="absolute -right-[10px] -top-[10px] bg-white rounded-full">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.03 10.2L11.36 14.86C11.22 15.01 11.03 15.08 10.83 15.08C10.64 15.08 10.45 15.01 10.3 14.86L7.97 12.53C7.68 12.24 7.68 11.76 7.97 11.47C8.26 11.18 8.74 11.18 9.03 11.47L10.83 13.27L14.97 9.14001C15.26 8.84001 15.74 8.84001 16.03 9.14001C16.32 9.43001 16.32 9.90001 16.03 10.2Z" fill="#1ba672" />
                            </svg>
                          </div>}
                          <div className="flex items-start gap-[10px]">
                            <img src={`${BaseUrl}/${item.address_image}`} className="max-w-[20px]" alt="address_image" />
                            <div className="-mt-[5px] flex flex-col items-start h-full justify-center">
                              <div className="">
                                <h1 className="text-[#02060c] text-[17px] font-[700]">{item.type}</h1>
                                <p className="text-[rgba(2,6,12,.6)] font-[500] text-[15px] leading-4">{`${item.hno}, ${item.landmark}, ${item.address}`}</p>
                              </div>
                              <button className="w-[150px] border-[1px] rounded-[5px] border-[#1ba672] bg-[#1ba672] text-[white] font-[700] py-[5px] text-[15px] mt-[10px]">DELIVER HERE</button>
                            </div>
                          </div>
                          <button onClick={(e) => { e.stopPropagation(); setShowOtion(isOpen ? "" : item.id); setDeleteadsId(item.id) }} className="p-[5px] relative">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.02 5.5C11.191 5.5 10.515 4.829 10.515 4C10.515 3.171 11.182 2.5 12.01 2.5H12.02C12.849 2.5 13.52 3.171 13.52 4C13.52 4.829 12.849 5.5 12.02 5.5ZM13.52 12C13.52 11.171 12.849 10.5 12.02 10.5H12.01C11.182 10.5 10.515 11.171 10.515 12C10.515 12.829 11.191 13.5 12.02 13.5C12.849 13.5 13.52 12.829 13.52 12ZM13.52 20C13.52 19.171 12.849 18.5 12.02 18.5H12.01C11.182 18.5 10.515 19.171 10.515 20C10.515 20.829 11.191 21.5 12.02 21.5C12.849 21.5 13.52 20.829 13.52 20Z" fill="#25314C" />
                            </svg>

                            {isOpen && <div style={{ boxShadow: "0 0 20px rgba(0, 0, 0, 0.25)" }} className="absolute top-[15px] -left-[85px] bg-white py-[5px]">
                              <div onClick={() => handleEditAddress(item)} className="flex items-center gap-[5px] py-[2px] ps-[10px] pe-[15px]">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17.0371 11.577C17.1541 11.694 17.1541 11.8849 17.0371 12.0019L8 21H3V16L11.998 6.963C12.115 6.845 12.3051 6.845 12.4231 6.963L17.0371 11.577ZM20.4099 5.81005L18.1899 3.58995C17.4059 2.80595 16.1341 2.80595 15.3501 3.58995L13.4719 5.468C13.3549 5.58501 13.3549 5.77496 13.4719 5.89196L18.1079 10.5279C18.2249 10.6449 18.415 10.6449 18.532 10.5279L20.4099 8.65001C21.1939 7.86601 21.1939 6.59405 20.4099 5.81005Z" fill="#04091E" />
                                </svg>
                                <h1 className="text-[15px] font-[500]">Edit</h1>
                              </div>
                              <div onClick={() => handleShowModel(1)} className="flex items-center gap-[5px] py-[2px] ps-[10px] pe-[15px]">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M20.75 6C20.75 6.414 20.414 6.75 20 6.75H4C3.586 6.75 3.25 6.414 3.25 6C3.25 5.586 3.586 5.25 4 5.25H8.214C8.307 5.068 8.37899 4.862 8.45599 4.632L8.658 4.02499C8.862 3.41299 9.43499 3 10.081 3H13.919C14.565 3 15.138 3.41299 15.342 4.02499L15.544 4.632C15.621 4.862 15.693 5.068 15.786 5.25H20C20.414 5.25 20.75 5.586 20.75 6ZM18.56 7.75C18.733 7.75 18.871 7.89701 18.859 8.07001L18.19 18.2C18.08 19.78 17.25 21 15.19 21H8.81C6.75 21 5.92 19.78 5.81 18.2L5.141 8.07001C5.13 7.89701 5.267 7.75 5.44 7.75H18.56ZM10.75 11C10.75 10.59 10.41 10.25 10 10.25C9.59 10.25 9.25 10.59 9.25 11V16C9.25 16.41 9.59 16.75 10 16.75C10.41 16.75 10.75 16.41 10.75 16V11ZM14.75 11C14.75 10.59 14.41 10.25 14 10.25C13.59 10.25 13.25 10.59 13.25 11V16C13.25 16.41 13.59 16.75 14 16.75C14.41 16.75 14.75 16.41 14.75 16V11Z" fill="#25314C" />
                                </svg>
                                <h1 className="text-[15px] font-[500]">Delete</h1>
                              </div>
                            </div>}

                          </button>
                        </div>
                      })}

                      <div onClick={() => HandleGetGoogleAddress(Number(mapcoords.lat), Number(mapcoords.long))} className="newaddres_box">
                        <div className="">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM15.25 11C15.25 11.414 14.914 11.75 14.5 11.75H12.75V13.5C12.75 13.914 12.414 14.25 12 14.25C11.586 14.25 11.25 13.914 11.25 13.5V11.75H9.5C9.086 11.75 8.75 11.414 8.75 11C8.75 10.586 9.086 10.25 9.5 10.25H11.25V8.5C11.25 8.086 11.586 7.75 12 7.75C12.414 7.75 12.75 8.086 12.75 8.5V10.25H14.5C14.914 10.25 15.25 10.586 15.25 11Z" fill="black" />
                          </svg>
                        </div>
                        <div className="-mt-[5px] flex flex-col items-start h-full justify-center">
                          <div className="">
                            <h1 className="text-[#02060c] text-[17px] font-[700]">Add new Address</h1>
                            <p className="text-[rgba(2,6,12,.6)] font-[500] text-[15px] leading-4">{locationsearch}</p>
                          </div>
                          <button className="w-[150px] border-[1px] border-[#1ba672] rounded-[5px] text-[#1ba672] font-[700] py-[5px] text-[15px] mt-[10px]">ADD NEW</button>
                        </div>
                      </div>

                    </div>
                  </div>
                  : <div className="">
                    <h1 className="text-[#02060c] text-[18px] font-[700]">Account</h1>
                    <p className="text-[rgba(2,6,12,.6)] font-[500]">To place your order now, log in to your existing account or sign up.</p>
                    <button onClick={() => setShowLoginPage(true)} className="w-[200px] mt-[20px] border-[2px] border-[#1ba672] text-[#1ba672] font-bold py-[8px] hover:text-white hover:bg-[#1ba672] rounded-[10px]">LOG IN</button>
                  </div>}

              </div>
            </div>

            <div className="detail_box">

              <div className="section_1">

                <div onClick={handleNavigete} className="res_box">
                  <img src={`${BaseUrl}/${restaurantdata?.rest_img}`} className='rounded-[5px]' alt="res_img" />
                  <div className="title">
                    <h1 className="text-[17px] text-[#02060c] font-[700]">{restaurantdata?.rest_title}</h1>
                    <p className="text-[15px] text-gray-600 font-[500]">{restaurantdata?.rest_full_address}</p>
                  </div>
                </div>

                <div className="order_box">
                  {cartdata.map((item, index) => {
                    return <div key={index} className="item_box">
                      <div className="flex items-start gap-[5px] overflow-hidden">
                        {item.type === "1" ?
                          <img src={VegIcon} className="w-[15px] mt-[2px]" alt="VegIcon" />
                          : <img src={NonVegIcon} className="w-[15px] mt-[2px]" alt="NonVegIcon" />}
                        <div className="leading-4">
                          <h1 className="text-[15px] text-[#02060c] font-[700] line-clamp-2 leading-4">{item.title}</h1>
                          {item.is_customize !== "0" && <button onClick={() => handleCustomisable(item, index)} className="font-[500] text-gray-600 text-[12px] flex items-center gap-[5px]">
                            <span>Customisable</span>
                            <svg width="6" height="8" className="text-[--bgcolor] mt-[3px]" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.00002 9.75002C0.808023 9.75002 0.615994 9.67705 0.469994 9.53005C0.176994 9.23705 0.176994 8.76202 0.469994 8.46902L3.93996 4.99905L0.469994 1.52908C0.176994 1.23608 0.176994 0.761041 0.469994 0.468041C0.762994 0.175041 1.23803 0.175041 1.53103 0.468041L5.53103 4.46804C5.82403 4.76104 5.82403 5.23608 5.53103 5.52908L1.53103 9.52908C1.38403 9.67708 1.19202 9.75002 1.00002 9.75002Z" fill="currentColor" />
                            </svg>
                          </button>}
                        </div>
                      </div>
                      <div className="flex items-center gap-[10px]">
                        <div className="border-[1px] border-gray-300 flex items-center py-[2px] gap-[5px] font-bold rounded-[5px]">
                          <button onClick={() => handleDecrement(index)} className="text-[17px] px-[10px] text-gray-400 -mt-[3px]">-</button>
                          <span className="text-[#1ba672]">{item.qty}</span>
                          <button onClick={() => handleIncrement(index)} className="text-[17px] text-[#1ba672] px-[10px] -mt-[2px]">+</button>
                        </div>
                        <div className="">
                          <h1 className="font-[500] text-[15px]">{currency + item.cost}</h1>
                        </div>
                      </div>
                    </div>
                  })}
                </div>

                <div className="mt-[20px] flex items-center gap-[8px] border p-[10px] rounded-[5px]">
                  <svg className="w-[15px]" viewBox="0 0 32 32">
                    <path d="M7.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.357-0.056 0.724-0.086 1.097-0.086zM25.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.358-0.056 0.724-0.086 1.097-0.086z"></path>
                  </svg>
                  <input type="text" value={additionalnot} onChange={(e) => setAdditionalNot(e.target.value)} className="w-full outline-none font-[500] text-[15px] bg-transparent" placeholder="Any suggestions? We will pass it on..." />
                </div>

                {(Userid && couponlist.length >= 1) && <div className="mt-[20px]">
                  <div onClick={() => { !selectcoupon && setShowCoupon(true); setIsDriverSelected(false) }} className="w-full border-[1px] border-dashed border-gray-400 p-[15px] cursor-pointer hover:shadow-lg rounded-[5px]">
                    <div className={`${selectcoupon ? "cursor-auto" : "cursor-pointer"}`}>
                      {selectcoupon
                        ? <div className="flex items-center justify-between">
                          <div className="leading-4">
                            <h1 className="text-[rgba(2,6,12,.9)] text-[14px] font-bold">{selectcoupon?.ccode}</h1>
                            <p className="text-[13px] text-gray-600 font-[500]">Offer applied on the bill</p>
                          </div>
                          <button onClick={() => setSelectCoupon("")} className="font-bold hover:text-[--bgcolor]">REMOVE</button>
                        </div>
                        : <div className="flex items-center gap-[10px]">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0001 21.75C11.3971 21.75 10.8311 21.515 10.4061 21.089L9.09002 19.773C8.95002 19.634 8.75711 19.554 8.56011 19.554H6.70208C5.45908 19.554 4.44707 18.543 4.44707 17.299V15.441C4.44707 15.241 4.3691 15.052 4.2271 14.91L2.91106 13.594C2.03306 12.715 2.03306 11.285 2.91106 10.406L4.2271 9.08898C4.3671 8.94898 4.44707 8.75598 4.44707 8.55898V6.70098C4.44707 5.45798 5.45908 4.44601 6.70208 4.44601H8.56011C8.75711 4.44601 8.95102 4.36598 9.09002 4.22698L10.4061 2.911C11.2561 2.059 12.744 2.059 13.594 2.911L14.9101 4.22698C15.0521 4.36898 15.2401 4.44601 15.4411 4.44601H17.298C18.541 4.44601 19.553 5.45698 19.553 6.70098V8.55898C19.553 8.75598 19.633 8.94998 19.773 9.08898L21.089 10.405C21.967 11.284 21.967 12.714 21.089 13.593L19.773 14.909C19.631 15.051 19.553 15.239 19.553 15.44V17.298C19.553 18.541 18.541 19.553 17.298 19.553H15.4411C15.2401 19.553 15.0511 19.631 14.9101 19.772L13.594 21.088C13.169 21.515 12.6031 21.75 12.0001 21.75ZM6.7011 5.94601C6.2851 5.94601 5.9461 6.28498 5.9461 6.70098V8.55898C5.9461 9.15998 5.71204 9.72499 5.28704 10.15L3.971 11.466C3.677 11.76 3.677 12.239 3.971 12.534L5.28704 13.85C5.71204 14.276 5.9461 14.84 5.9461 15.441V17.299C5.9461 17.715 6.2851 18.054 6.7011 18.054H8.55901C9.15201 18.054 9.73108 18.294 10.1501 18.713L11.466 20.029C11.751 20.314 12.247 20.314 12.532 20.029L13.8481 18.712C14.2731 18.287 14.838 18.053 15.44 18.053H17.297C17.713 18.053 18.0521 17.714 18.0521 17.298V15.44C18.0521 14.839 18.2861 14.274 18.7111 13.849L20.027 12.533C20.321 12.239 20.321 11.76 20.027 11.465L18.7111 10.149C18.2861 9.72398 18.0521 9.15901 18.0521 8.55801V6.7C18.0521 6.284 17.713 5.945 17.297 5.945H15.44C14.838 5.945 14.2731 5.711 13.8481 5.286L12.532 3.96999C12.247 3.68499 11.751 3.68499 11.466 3.96999L10.1501 5.28698C9.73108 5.70598 9.15201 5.94601 8.55901 5.94601H6.7011ZM20.5601 13.064H20.57H20.5601ZM10.0301 15.03L15.0301 10.03C15.3231 9.73699 15.3231 9.26199 15.0301 8.96899C14.7371 8.67599 14.262 8.67599 13.969 8.96899L8.96905 13.969C8.67605 14.262 8.67605 14.737 8.96905 15.03C9.11505 15.176 9.30708 15.25 9.49908 15.25C9.69108 15.25 9.88408 15.177 10.0301 15.03ZM10.502 9.49999C10.502 8.94799 10.055 8.49999 9.50201 8.49999H9.492C8.94 8.49999 8.497 8.94799 8.497 9.49999C8.497 10.052 8.95001 10.5 9.50201 10.5C10.055 10.5 10.502 10.052 10.502 9.49999ZM15.502 14.5C15.502 13.948 15.055 13.5 14.502 13.5H14.492C13.94 13.5 13.497 13.948 13.497 14.5C13.497 15.052 13.95 15.5 14.502 15.5C15.055 15.5 15.502 15.052 15.502 14.5Z" fill="#25314C" />
                          </svg>
                          <h1 className="font-[500] text-gray-800">Apply Coupon</h1>
                        </div>}
                    </div>
                  </div>
                </div>}

                {WalletAmt !== "0" && <div className="mt-[20px]">
                  <div className="border-[1px] border-dashed border-gray-400 rounded-[5px] py-[10px] px-[20px]">
                    <div className="flex items-center justify-between mb-[10px]">
                      <h1 className='font-[500] text-[17px]'>Pay from Wallet</h1>
                      <label className="switch">
                        <input type="checkbox" checked={isDriverSelected} onChange={() => setIsDriverSelected(!isDriverSelected)} />
                        <span className="slider round"></span>
                      </label>
                    </div>

                    <div className="border-[1px] border-dashed border-gray-400 p-[10px] rounded-[5px]">
                      <div className="flex items-center gap-[10px] justify-between">
                        <div className="flex items-center gap-[10px]">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="black" />
                          </svg>
                          <h1 className='font-[500]'>My Wallet</h1>
                        </div>
                        <p className='font-bold text-[--bgcolor]'>{currency} {mywallet - usedwallet}</p>
                      </div>
                    </div>

                  </div>
                </div>}

                {tip !== 0 && <div className="mt-[20px] border p-[10px] rounded-[5px]">
                  <h1 className="font-[500] text-[15px]">Tip your hunger saviour</h1>
                  <div className="flex items-center gap-[10px]">
                    <p className="text-[13px] text-gray-500 leading-4">Thank your delivery partner for helping you stay safe indoors, Support them through these tough time with a tip.</p>
                    <img src={DeliverLogo} className="w-[60px]" alt="DeliverLogo" />
                  </div>
                  <div className="flex items-center justify-center gap-[20px] mt-[10px]">
                    {tip.map((item, index) => {
                      const IsSelect = selecttip === item;
                      return <button key={index} onClick={() => { setSelectTip(IsSelect ? 0 : item); setIsDriverSelected(false); }} className={`${IsSelect && "text-[--bgcolor] border-[--bgcolor]"} font-bold border px-[20px] py-[4px] rounded-[10px] hover:text-[--bgcolor] hover:border-[--bgcolor]`}>{currency + item}</button>
                    })}
                  </div>
                </div>}

                <div className="mt-[20px]">
                  <h1 className="text-[#02060c] font-[500]">Bill Details</h1>

                  <div className="text-[rgba(2,6,12,.7)] mb-[10px]">
                    <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Item Total</h1>
                      <span>{currency + itemtotal}.0</span>
                    </div>

                    <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Delivery Fee | {restaurantdata?.rest_distance} KM</h1>
                      <span>{currency + restaurantdata?.rest_dcharge}.0</span>
                    </div>

                    <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Restaurent Charges</h1>
                      <span>{currency + restaurantdata?.rest_charge}.0</span>
                    </div>

                    <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Taxes and Charges ({TaxPrs}%)</h1>
                      <span>{currency + tax}.0</span>
                    </div>

                    {selectcoupon && <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Coupon Amount</h1>
                      <span>- {currency + selectcoupon?.cvalue}.0</span>
                    </div>}

                    {isDriverSelected && <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Wallet Amount</h1>
                      <span>- {currency + usedwallet}.0</span>
                    </div>}

                    {selecttip !== 0 && <div className="text-[14px] font-[500] flex items-center justify-between py-[2px]">
                      <h1>Delivery Tip</h1>
                      <span>{currency + selecttip}.0</span>
                    </div>}

                  </div>

                  <div className="border-t-[2px] border-black">
                    <div className="text-[14px] text-black font-bold flex items-center justify-between pt-[10px]">
                      <h1>TO PAY</h1>
                      <span>{currency + totalpay}.0</span>
                    </div>
                  </div>

                </div>

                {Userid && <button onClick={handleProceed} className="w-full text-white font-bold text-[17px] rounded-[5px] bg-[#1ba672] mt-[20px] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]">PROCEED TO PAY</button>}

              </div>

            </div>

          </div>
        </div>}

      {iscustomisable && <div onClick={() => handleCloseModel(1)} className="model items-center max-_430_:items-end">
        <div onClick={(e) => e.stopPropagation()} className="customisable_box">

          <div className="py-[20px] px-[15px]">
            <div className="flex items-center justify-between">
              <h1 className="text-[15px] text-gray-600">{selectitem?.title} • {currency + selectitem?.price}</h1>
              <button onClick={() => handleCloseModel(1)} className="bg-white rounded-full p-[4px] box_shadow" >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                </svg>
              </button>
            </div>
            <p className="text-[20px] font-bold text-gray-800 border-b-[1px] pb-[10px] border-gray-300">Customise as per your taste</p>
          </div>

          {!subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">
            {customisableitem?.addondata.map((addon, index) => {
              const Required = addon.addon_limit;
              return <div key={index} className="addondata_box">

                <div className="flex items-center gap-[10px]">
                  <h1 className="title">{addon.title}</h1>
                  {addon.addon_is_radio === "1"
                    ? <span className="font-bold text-[16px] text-gray-500">
                      ({addon.additem || "0"}/1)
                    </span>
                    : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                      ({addon.additem || "0"}/{Required})
                    </span>)}
                </div>

                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                  {addon.addon_item_data.map((dataItem, index) => {
                    const hasSubAddon = dataItem.subaddondata?.length >= 1;
                    return <AddonItemData
                      index={index}
                      Required={Required}
                      key={dataItem.id}
                      addondata={addon}
                      data={dataItem}
                      currency={currency}
                      setSelectAddonItem={setSelectAddonItem}
                      selectaddonitem={selectaddonitem}
                      setSubAddonData={setSubAddonData}
                      hasSubAddon={hasSubAddon}
                      setItemState={setItemState}
                      itemstate={itemstate}
                      copyitemstate={copyitemstate}
                      isedit={isedit}
                      ischnage={ischange}
                    />
                  })}
                </div>

              </div>
            })}
          </div>}

          {subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">

            <div className="bg-white px-[15px] py-[20px] rounded-[10px] mb-[10px]">
              <div className="flex items-center gap-[10] justify-between">
                <h1 className="font-[500] text-[16px]">• {subAddonData?.title}</h1>
                <button onClick={() => handleCloseModel(2)} className="font-bold text-[16px] text-[--bgcolor]">Change</button>
              </div>
            </div>

            {subAddonData.subaddondata.map((addon, index) => {
              const Required = addon.addon_limit;
              return <div key={index} className="addondata_box">
                <div className="flex items-center gap-[10px]">
                  <h1 className="title">{addon.title}</h1>
                  {addon.addon_is_radio === "1"
                    ? <span className="font-bold text-[16px] text-gray-500">
                      ({addon.additem || "0"}/{addon.addon_is_required})
                    </span>
                    : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                      ({addon.additem || "0"}/{Required})
                    </span>)}
                </div>

                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                  {addon.subon_item_data.map((dataItem, index) => {
                    return (
                      <SubAddonItemData
                        index={index}
                        Required={Required}
                        key={dataItem.id}
                        addondata={addon}
                        data={dataItem}
                        currency={currency}
                        hasSubAddon={true}
                        setSubAddonData={setSubAddonData}
                        subAddonData={subAddonData}
                        setItemState={setItemState}
                        itemstate={itemstate}
                        selectaddonitem={selectaddonitem}
                        isedit={isedit}
                      />
                    );
                  })}
                </div>

              </div>
            })}
          </div>}

          <div className="bg-white p-[16px] flex items-center justify-between gap-[20px]">
            <div className="font-bold text-[18px]">
              {addonlimit !== 0 ? ((!subaddonshow)
                ? <h1>Step ({isstep}/{addonlimit})</h1>
                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price * selectitemqty)} </h1>)
                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price * selectitemqty)} </h1>}
            </div>
            <button onClick={(addonlimit !== 0 && !subaddonshow) ? handleContinue2 : handleUpdateCart} className="w-[300px] bg-[rgb(27,166,114)] text-white font-bold text-[18px] py-[8px] rounded-[12px]">
              {(addonlimit !== 0 && !subaddonshow)
                ? <span>Continue</span>
                : <span>Update Cart</span>}
            </button>
          </div>

        </div>
      </div>}

      <div className={`coupon_model ${showcoupon && "coupon_model_open"}`}>

        <button onClick={() => setShowCoupon(false)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
          </svg>
        </button>

        {couponlist.length >= 1
          ? <div className="coupon_box">
            {couponlist.map((item, index) => {
              const isLoading = loadingCouponCode === item.coupon_code;
              const isApply = selectcoupon?.cid === item.id;
              return <div key={index} className="border-[1px] border-gray-300 px-[20px] py-[15px] mt-[10px] rounded-[10px]">
                <div className="flex items-start gap-[20px]">
                  <img src={`${BaseUrl}/${item.c_img}`} className="w-[80px] h-[80px] object-cover rounded-[5px]" alt="c_img" />
                  <div>
                    <div className="leading-5">
                      <h1 className=" font-[500] text-[17px]">Get {item.coupon_title}</h1>
                      <p className="text-[15px] text-gray-600">{item.subtitle}</p>
                    </div>
                    <div>
                      <h1>Coupon Code : <span className='font-[500] text-[#1ba672]'>{item.coupon_code}</span></h1>
                      <h1>Coupon Amount : <span className='font-[500]'>{currency}{item.c_value}</span></h1>
                      <h1>Minimum Amount : <span className='font-[500]'>{currency}{item.min_amt}</span></h1>
                      <h1>Ex Date : <span className='font-[500]'>{item.cdate}</span></h1>
                    </div>
                    <button onClick={() => isApply ? setSelectCoupon("") : handleCheckCoupone(item)} disabled={itemtotal < item.min_amt} className={`rounded-[5px] ${itemtotal < item.min_amt ? "apply_btn_false" : "apply_btn_true"}`}>
                      {isLoading
                        ? <div style={{ width: "23px", height: "23px" }} className="loader mx-auto"></div>
                        : <span>{isApply ? "REMOVE COUPON" : "APPLY COUPON"}</span>}
                    </button>
                  </div>
                </div>
              </div>
            })}
          </div>
          : <div className="h-[calc(100%-50px)] flex items-center justify-center">
            <h1 className="font-bold text-gray-500 text-[17px]">Sorry, Coupon List Empty !!</h1>
          </div>}

      </div>

      <div className={`address_model ${showaddress && "address_model_open"}`}>

        <button className="w-full flex justify-end" onClick={() => { setShowAddress(false); setMapData({ houseno: '', landmark: "", type: "" }); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
          </svg>
        </button>

        <div className="w-full flex justify-end my-[20px]">
          <div className="addres_box">
            <div className="google_map">
              {isLoaded && <GoogleMap
                center={{ lat: Number(mapcoords.lat), lng: Number(mapcoords.long) }}
                zoom={15}
                onClick={handleMapClick}
                options={{
                  mapTypeControl: false,
                  fullscreenControl: false,
                  streetViewControl: false,
                  zoomControl: false,
                }}
              >
                <Marker icon={{ url: MapPin, scaledSize: new window.google.maps.Size(32, 32), }} position={{ lat: Number(mapcoords.lat), lng: Number(mapcoords.long) }} />
              </GoogleMap>}
            </div>

            <div className="mt-[20px]">
              <div className="border border-[rgba(2,6,12,.2)] px-[15px] rounded-[5px]">
                <div className="relative">
                  <input value={mapaddres || ""} readOnly
                    type="text"
                    id="addres"
                    placeholder=""
                    className="peer w-full font-bold h-[65px] outline-none pt-[15px]"
                  />
                  <label
                    htmlFor="addres"
                    className={`absolute left-0 cursor-text text-gray-500 font-medium text-sm transition-all duration-200
                      ${(!mapaddres)
                        ? 'peer-placeholder-shown:top-[20px] peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500'
                        : 'top-[10px] text-xs'} peer-focus:top-[10px] peer-focus:text-xs`}
                  >
                    ADDRESS
                  </label>
                </div>
              </div>

              <div className="border border-[rgba(2,6,12,0.2)] mt-1 px-4 rounded-[5px]">
                <div className="relative">
                  <input
                    id="houseno"
                    type="text"
                    value={mapdata?.houseno || ""}
                    onChange={(e) =>
                      setMapData({ ...mapdata, houseno: e.target.value })
                    }
                    placeholder=" "
                    className="peer w-full h-16 pt-4 font-bold outline-none"
                  />
                  <label
                    htmlFor="houseno"
                    className={`absolute left-0 text-gray-500 font-medium transition-all duration-200
        ${!mapdata?.houseno
                        ? 'peer-placeholder-shown:top-5 peer-placeholder-shown:text-base'
                        : 'top-2 text-xs'}
        peer-focus:top-2 peer-focus:text-xs`}
                  >
                    HOUSE / FLAT / BLOCK NO.
                  </label>
                </div>
              </div>


              <div className="border border-[rgba(2,6,12,.2)] mt-[5px] px-[15px] rounded-[5px]">
                <div className="relative">
                  <input value={mapdata?.landmark || ""} onChange={(e) => setMapData({ ...mapdata, landmark: e.target.value })}
                    type="text"
                    id="apartment"
                    placeholder=""
                    className="peer w-full font-bold h-[65px] outline-none pt-[15px]"
                  />
                  <label
                    htmlFor="apartment"
                    className={`absolute left-0 cursor-text text-gray-500 font-medium text-sm transition-all duration-200
                      ${(!mapdata?.landmark)
                        ? 'peer-placeholder-shown:top-[20px] peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500'
                        : 'top-[10px] text-xs'} peer-focus:top-[10px] peer-focus:text-xs`}
                  > APARTMENT / ROAD / AREA
                  </label>
                </div>
              </div>

              <div className="mt-[5px] flex items-center gap-[5px]">
                {AddresType?.map((item, index) => {
                  const IsAdded = istype?.includes(item.type);
                  return <button key={index} onClick={() => handleSelectAddrestype(item.type, IsAdded)} className={`rounded-[5px] ${IsAdded ? "addres_type_des" : "addres_type"}`}>
                    <span className={`${IsAdded && mapdata.type !== item.type && "text-gray-500"} ${mapdata.type === item.type && "text-[--bgcolor]"}`}>{item.icon}</span>
                    <h1 className={`font-[500] ${mapdata.type === item.type && "text-[--bgcolor]"}`}>{item.type}</h1>
                  </button>
                })}
              </div>
            </div>

            <button onClick={handleSaveAddres} className="w-full text-white rounded-[5px] font-bold text-[17px] bg-[#1ba672] mt-[20px] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]">
              {apiloading
                ? <div className="btn_loader mx-auto"></div>
                : <span>ADD NEW ADDRESS</span>}
            </button>

          </div>
        </div>

      </div>

      {showpayment && <div onClick={() => setShowPayment(false)} className="model items-end">
        <div onClick={(e) => e.stopPropagation()} className="bg-white w-[450px] rounded-t-[10px]">
          <h1 className="font-[500] text-[18px] px-[20px] pt-[15px] text-gray-600">Select Payment Method</h1>

          <div className="h-[400px] px-[20px] scroll_container">
            {paymentlist?.map((item, index) => {
              const isSelect = item.id === selectpayment;
              if (item.status === "1") {
                return <div key={index} onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} className={`payment_box border-[2px] ${isSelect ? "border-[--bgcolor]" : ""}`}>
                  <div className="flex items-center gap-[10px]">
                    <img src={`${BaseUrl}/${item.img}`} className="w-[65px] max-h-[65px] border-[2px] rounded-[20px]" alt="img" />
                    <div className="">
                      <h1 className="font-[500] text-[17px]">{item.title}</h1>
                      <p className="text-[15px] text-gray-600 font-[500] leading-[18px]">{item.subtitle}</p>
                    </div>
                  </div>
                  <div className="w-[30px]">
                    <div className={`w-[18px] h-[18px] rounded-full border-[2px] p-[2px] duration-[.5s] ${isSelect ? "border-[--bgcolor]" : ""}`}>
                      <div className={`w-full h-full rounded-full duration-[.5s] ${isSelect ? "bg-[--bgcolor]" : "bg-transparent"}`}></div>
                    </div>
                  </div>
                </div>
              }
            })}
          </div>

          <div className=" bg-white py-[10px] px-[20px]">
            <button onClick={handleContinue} className="w-full text-white rounded-[5px] font-bold text-[17px] bg-[--bgcolor] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]">
              {paymentloading
                ? <div className="btn_loader mx-auto"></div>
                : <span>CONTINUE</span>}
            </button>
          </div>
        </div>
      </div>}

      {showcoupon && <div onClick={() => setShowCoupon(false)} className="overlay z-[888]"></div>}
      {showaddress && <div onClick={() => { setShowAddress(false); setMapData({ houseno: '', landmark: "", type: "" }); }} className="overlay z-[888]"></div>}

      {isshow && <div onClick={() => handleShowModel(2)} className="w-full h-[100vh] fixed left-0 right-0 bottom-0 flex items-end justify-center z-[888]">
        <div ref={StyleRef} onClick={(e) => e.stopPropagation()} className="item_added">
          <h1>Are you sure you want to delete this address?</h1>
          <div className="flex items-center gap-[20px] mt-[20px]">
            <button onClick={() => handleShowModel(2)} className="w-full border-[2px] border-[--bgcolor] text-[--bgcolor] font-bold text-[15px] py-[10px] hover:shadow-lg">CANCEL</button>
            <button onClick={() => handleDeleteAddress(deleteadsid)} className="w-full border-[2px] border-[--bgcolor] bg-[--bgcolor] text-white font-bold text-[15px] py-[10px] hover:shadow-lg">DELETE</button>
          </div>
        </div>
      </div>}

      {(selectpayment === "1" && istrue) && <Razorpay Amount={totalpay} attributes={attributes} />}
      {(selectpayment === "3" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
          <div className="flex flex-col justify-center items-center text-center">
            <Paypal Amount={totalpay} attributes={attributes} />
          </div>
        </div>
      </div>}
      {(selectpayment === "4" && istrue) && <div onClick={() => { setSelectPayment(""); setIsTrue(false) }} className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
          <div className="flex flex-col justify-center items-center text-center">
            <Stripe Amount={totalpay} />
          </div>
        </div>
      </div>}
      {(selectpayment === "6" && istrue) && <PayStack Amount={totalpay} attributes={attributes} />}
      {(selectpayment === "7" && istrue) && <FlutterWave Amount={totalpay} attributes={attributes} />}
      {(selectpayment === "8" && istrue) && <PaytmPayment Amount={totalpay} />}
      {(selectpayment === "11" && istrue) && <MercadoPago Amount={totalpay} />}
      {(selectpayment === "12" && istrue) && <PayFast Amount={totalpay} attributes={attributes} />}
      {(selectpayment === "13" && istrue) && <Midtrans Amount={totalpay} />}
      {(selectpayment === "15" && istrue) && <KhaltiPayment Amount={totalpay} />}
    </div>
  )
}

export default Checkout;